module.exports = __webpack_public_path__ + "static/media/kargin_blot_bazarblot.0a0f92e5.png";